import React from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';

import styled from 'styled-components';
import { ContactSupportTwoTone } from '@material-ui/icons';

// Register the necessary Chart.js components
ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);


const RadarChart = ({ individualscores, ready }) => {

  if (!individualscores) return null;

  const data = {
    labels: individualscores.map((val) => val.title),
    datasets: [
      {
        label: 'Score',
        data: individualscores.map((val) => val.score), 
        fill: true,
        backgroundColor: 'rgba(34, 202, 236, 0.5)', 
        borderColor: 'rgba(34, 202, 236, 1)',
        pointBackgroundColor: 'rgba(34, 202, 236, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(34, 202, 236, 1)',
        tension: 0.05,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      r: {
        pointLabels: {
          display:true,
          callback: () => {},
        },
        angleLines: {
          display: true,
          color: 'rgba(0, 0, 0, 0.1)',
          lineWidth: 1,
        },
        grid: {
          circular: false,
          color: 'rgba(0, 0, 0, 0.1)',
          lineWidth: 20,
        },
        ticks: {
          display: false,
          suggestedMin: 0,
          suggestedMax: 1,
          stepSize: 0.95,
        },
      },
    },
  };

  return <RadarContainer>
            <RadarTopLabel>
                <RadarBottomLabelEach>
                    <RadarLabel>{data.labels[0]}</RadarLabel>
                    <RadarFigure format={data.datasets[0].data[0] > 0.85 ? 'positive' : 'negative'}>{(data.datasets[0].data[0] * 100).toFixed(1)}</RadarFigure>
                </RadarBottomLabelEach>
            </RadarTopLabel>
            <RadarInnerContainer>
                <Radar data={data} options={options} />
            </RadarInnerContainer>
            <RadarBottomLabels>
                <RadarBottomLabelEach>
                    <RadarLabel>{data.labels[2]}</RadarLabel>
                    <RadarFigure format={data.datasets[0].data[2] > 0.85 ? 'positive' : 'negative'}>{(data.datasets[0].data[2] * 100).toFixed(1)}</RadarFigure>
                </RadarBottomLabelEach>
                <RadarBottomLabelEach>
                    <RadarLabel>{data.labels[1]}</RadarLabel>
                    <RadarFigure format={data.datasets[0].data[1] > 0.85 ? 'positive' : 'negative'}>{(data.datasets[0].data[1] * 100).toFixed(1)}</RadarFigure>
                </RadarBottomLabelEach>
            </RadarBottomLabels>
    </RadarContainer>
;
};

export default RadarChart;

const RadarLabel = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    align-content:center;
    justify-content:center;
    font-size:14px;
    color: rgb(26, 55, 100);
`

const RadarFigure = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    align-content:center;
    justify-content:center;
    font-size:14px;
    padding-left:5px;
    color: ${props => {
        switch (props.format) {
            case 'positive':
                return 'rgb(88, 192, 164)';
            case 'negative':
                return 'rgb(236, 120, 125)';
            default:
                return 'rgb(26, 55, 100)';
        }
    }};
    font-weight:bold;
`

const RadarContainer = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    align-content:center;
    justify-content:center;
    width:100%;
    padding:20px;
`

const RadarInnerContainer = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    align-content:center;
    justify-content:center;
    padding:20px;
    padding-top:10px;
`

const RadarTopLabel = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
    align-content:center;
    justify-content:center;
    font-size:12px;
`

const RadarBottomLabels = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
    align-content:center;
    justify-content:space-between;
    width:100%;
    margin-top:-70px;
`

const RadarBottomLabelEach = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
    align-content:center;
    justify-content:center;
    font-size:12px;
    border-radius:30px;
`